
import { defineComponent } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import SvgBrokenQr from '@/components/Icons/SvgBrokenQr.vue';
import VirtualRedTagHeader from '@/components/VirtualRedTag/VirtualRedTagHeader.vue';

export default defineComponent({
    name: 'VirtualRedTagInvalidQr',
    components: {
        FbxButton,
        SvgBrokenQr,
        VirtualRedTagHeader,
    },
    emits: ['manualEntry', 'backToWelcome'],
});
